module.exports = __webpack_public_path__ + "static/media/nats.cdff498c.png";